<template>
	<dialog-generic :visibility.sync = 'visibility' :indicator = 'indicator' :max-width = '$vuetify.breakpoint.smAndUp ? "80%": "95%"'>
        <template v-slot:title> {{project.project_name}} </template>
        <template v-slot:content>
			<v-tabs 
                v-model = 'activeView' 
                :slider-color = '$store.getters.uiAccent' 
                :color = '$store.getters.uiAccent' 
                grow
            >
				<v-tab key = 'costs'>Представление расходов</v-tab>
				<v-tab key = 'custom'>Ключевые показатели</v-tab>
				<v-tab-item key = 'costs' style = 'max-height: 400px; overflow: scroll;'>
					<v-layout column align-center justify-center>
						<v-data-table
							disable-sort
							:headers = "header" 
							:items = "projectSchema.expected_fields"
							item-key = 'field_id'
							:server-items-length = 'projectSchema.expected_fields.length' 
							:expanded.sync = 'expandedDimension'
							hide-default-footer
							show-expand
							style = 'width: 100%;'
						>
							<template v-slot:item.type = '{ item }'>
								<v-chip 
									small 
									:color = 'item.type == "dimension"? "light-blue darken-1":"green lighten-1"'
								>{{item.type == 'dimension'? 'Параметр': 'Показатель'}}</v-chip>
							</template>
							<template v-slot:item.aggregation = '{ item }'>
								<span>{{item.aggregation == 'cast_date'? 'Дата': item.aggregation == 'text'? 'Строка':'Число'}}</span>
							</template>
							<template v-slot:item.regularity = '{ item }'>
								<v-chip 
									small
									:color = 'item.regularity == "default"? "light-blue lighten-4":"green lighten-1"'
								>{{item.regularity == 'default'? 'По умолчанию': 'Пользовательский'}}</v-chip>
							</template>
							<template v-slot:item.fields_count = '{ item }'>
								<span>{{item.fields.length}}</span>
							</template>
							<template v-slot:item.errored = '{ item }'>
								<v-tooltip left v-if = 'item.errored'>
									<template v-slot:activator = '{ on }'>
										<v-icon v-on = 'on' color = 'error'>mdi-alert</v-icon>
									</template>
									<span>В экспорте отсутствуют столбцы, необходимые для генерации поля</span>
								</v-tooltip>
							</template>
							<template v-slot:item.actions = '{ item }'>
								<v-btn class="mx-0" icon small @click = 'controllers.delete = true; schemaField = item;' v-if = 'item.regularity != `default`'>
									<v-icon :color = '$store.getters.uiAccent' small>delete_outline</v-icon>
								</v-btn>
							</template>
							<template v-slot:expanded-item = '{ item, headers }'>
								<td :colspan = "headers.length">
									<v-layout column mx-0 px-0>
										<v-list class = 'my-0 pa-0 ml-5 pl-5' dense>
											<v-list-item v-for = 'column in item.fields' :key = 'column.name' class = 'pa-0 ml-5'>
												<v-list-item-action><v-icon>mdi-text</v-icon></v-list-item-action>
												<v-list-item-content>
													<v-list-item-title class = 'body-2 font-weight-light'>{{column.name}}</v-list-item-title>
												</v-list-item-content>
												<v-list-item-action v-if = '!column.exists'>
													<v-tooltip left>
														<template v-slot:activator = '{ on }'>
															<v-icon v-on = 'on' color = 'error'>mdi-alert</v-icon>
														</template>
														<span>Столбец не найден в экспорте данных</span>
													</v-tooltip>
												</v-list-item-action>
											</v-list-item>
										</v-list>
									</v-layout>
								</td>
							</template>
							<template v-slot:body.append>
								<tr @click = 'controllers.create = true;' style = 'cursor: pointer; user-select: none;'>
									<td>
										<v-icon color = 'info'>mdi-plus</v-icon>
									</td>
									<td 
										:colspan = "header.length"
									>
										<span class='subheading font-weight-regular text-center'>Добавить столбец</span>
									</td>
								</tr>
							</template>
						</v-data-table>
					</v-layout>
				</v-tab-item>
				<v-tab-item key = 'custom' style = 'max-height: 400px; overflow: scroll;'>
					<v-layout column align-center justify-center>
						<span v-if = 'projectMetrics.length == 0' class = 'my-2'>Здесь вы можете добавить ключевые показатели по проекту для отслеживания их динамики</span>
						<v-list style = 'width: 100%;' v-else>
							<v-list-group v-for = 'f in projectMetrics' :key = 'f.metric_name'>
								<template v-slot:activator>
									<v-list-item>
										<v-list-item-action><v-icon>mdi-function-variant</v-icon></v-list-item-action>
										<v-list-item-content>
											<v-list-item-title class = 'text-left font-weight-medium'>{{f.metric_name}}</v-list-item-title>
										</v-list-item-content>
										<v-list-item-action>
											<v-chip>{{f.metric_fields.length}}</v-chip>
										</v-list-item-action>
									</v-list-item>
								</template>
								<v-layout column align-center class = 'black--text'>
									<pre class = 'my-1'> = {{f.metric_formula}}</pre>
								</v-layout>
							</v-list-group>
						</v-list>
						<v-list style = 'width: 100%;'>
							<v-list-item link @click = 'controllers.metric.create = true'>
								<v-list-item-action><v-icon>mdi-plus</v-icon></v-list-item-action>
								<v-list-item-content>
									<v-list-item-title>Добавить показатель</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list>
					</v-layout>
				</v-tab-item>
			</v-tabs>
			<create-sf :visibility = 'controllers.create' :fields = 'projectSchema.available_metrics_fields'></create-sf>
			<delete-sf :visibility = 'controllers.delete' :schemaField = 'schemaField'></delete-sf>
			<create-metric 
				:visibility.sync = 'controllers.metric.create' 
				:viewColumns = 'viewColumns' 
				:internalTables = 'columnsByInternalTable'
				@metricCreated = 'getProjectSchema'
			></create-metric>
        </template>
    </dialog-generic>
</template>

<style>
	.v-data-table__expanded__content {
		box-shadow: none !important;
	}
	.v-data-table__wrapper {
		line-height: 1.5 !important;
	}
</style>

<script>
	import projectHandlers from '@/mixins/project'
	import CreateMetric from '@/components/entities/projects/schema/CreateMetric.vue'
	import CreateSchemaField from '@/components/entities/projects/schema/CreateSchemaField.vue'
	import DeleteSchemaField from '@/components/entities/projects/schema/DeleteSchemaField.vue'
	import DialogGeneric from '@/components/elements/dialogs/Generic.vue'
	import { orderBy, groupBy, mapValues, omit } from 'lodash-es'

	export default {
		name: 'ProjectSchemaController',
		mixins: [projectHandlers],
		props: ['data', 'initialState'],
		components: {
			'create-sf': CreateSchemaField,
			'delete-sf': DeleteSchemaField,
			'dialog-generic': DialogGeneric,
			'create-metric': CreateMetric
		},
		data() {
			return {
				activeView: 0,
				controllers: {
					create: false,
					delete: false,
					metric: {
						create: false
					}
				},
				visibility: false,
				indicator: false,
				schemaField: {},
				header: [{
					text: '',
					value: 'type',
					sortable: false
				},{
					text: 'Название столбца',
					value: 'name',
					sortable: false
				}, {
					text: 'Тип данных',
					value: 'aggregation'
				}, {
					text: 'Тип поля',
					value: 'regularity',
					sortable: true
				}, {
					text: 'Включенные поля',
					value: 'fields_count',
					sortable: false
				}, {
					text: '',
					value: 'errored',
					sortable: false
				}, {
					text: '',
					value: 'actions',
					sortable: false
				}],
				expandedDimension: [],
				projectSchema: {
					expected_fields: [],
	                available_metrics_fields: []
				},
				projectMetrics: [],
				project: this.data
			}
		},
		watch: {
			initialState(value) {
	            this.visibility = value;
	        },
	        visibility(value) {
	            this.$root.$emit('projectSchemaVisibility', value);
	            if (value) {
	            	this.getProjectSchema()
	            }
			},
			activeView(){
				this.getProjectSchema()
			}
		},
		computed: {
			viewColumns() {
				return (this.projectSchema.views || []).filter( (s) => s.table_name.includes('view_costs_'))
			},
			columnsByView() {
				return mapValues(groupBy(this.projectSchema.views, 'table_name'))
			},
			columnsByInternalTable() {
				return mapValues(groupBy(this.projectSchema.internal_tables, 'table_name'))
			}
		},
		methods: {
			getProjectSchema() {
				this.indicator = true;
				let values = this.activeView == 0? 'schema': 'metrics'
				this.getProjectPropertyPromise(values).then( (r) => {
	            	this.indicator = false;
	            	if (r.body.result) {
						if (values == 'schema') {
							this.projectSchema = r.body.data
							this.projectSchema.all_fields = Array.from(
								new Set(
									this.projectSchema.funnel_tables
									.map((f) => ({name: f.column_name, type: f.data_type}))
								)
							)
							this.projectSchema.available_metrics_fields = this.projectSchema.all_fields
								.filter( (f) => !['DATE', 'STRING'].includes(f.type) && !f.name.includes('common_'))
								.map( (f) => f.name)
						} else {
							this.projectMetrics = r.body.data
							for (let metric in this.projectMetrics) {
								this.projectMetrics[metric].metric_fields = JSON.parse(this.projectMetrics[metric].metric_fields)
							}
						}
	            	}
	            })
			}
		},
		mounted() {
			this.$root.$on('CRUDSchemaVisibility', (value) => {
				this.controllers[value.type] = value.visibility
				if (value.update) {
					this.getProjectSchema()
				}
			})
		}
	}
</script>